{
  "clientError": {
    "title": "பிழை நேர்ந்துள்ளது",
    "body": {
      "line1": "உங்கள் கோரிக்கையில் ஏதோ சிக்கல் இருப்பதுபோல் தெரிகிறது. சரியான இணைப்பை உள்ளீடு செய்துள்ளீர்களா எனச் சரிபார்க்கவும் அல்லது சில நிமிடங்களுக்குப்பின் மீண்டும் முயலவும்."
    }
  },
  "serverError": {
    "title": "ஏதோ தவறு நேர்ந்துவிட்டது",
    "body": {
      "line1": "சேவையகத்தில் ஏதோ பிரச்சினைபோல் தெரிகிறது. அதனைச் சரிசெய்ய முயன்று வருகிறோம். இதனிடையே, பக்கத்தைப் புதுப்பிக்கவும் அல்லது சில நிமிடங்களுக்குப்பின் முயலவும். இல்லையேல், circs@sph.com.sg என்ற மின்னஞ்சல் முகவரி மூலம் எங்கள் வாடிக்கையாளர் சேவையைத் தொடர்புகொள்ளவும்."
    }
  },
  "pageNotFound": {
    "title": "அடடா! பக்கம் கண்டறியப்படவில்லை",
    "body": {
      "line1": "நீங்கள் தேடும் பக்கத்தைக் கண்டறிய முடியவில்லை. அது நீக்கப்பட்டிருக்கலாம் அல்லது தற்காலிகமாக பயன்படுத்த இயலாமல் இருக்கலாம். இணையத்தள முகவரியைச் சரிபார்க்கவும் அல்லது முன்னைய பக்கத்திற்குச் செல்லவும்."
    }
  }
}
